import React, { useEffect } from "react";
import { useState } from "react";
import Select from "react-select";
import * as api from "../../constant/API";
import Utils from "../../constant/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

interface ProfessionalProps {
    onDataChange: (data: any) => void
    userDet?: any;
    onBack: () => void
    isEdit: boolean;
    moduleDet: (data: any[]) => void;
    roleDet: (data: any[]) => void;
    submit: () => void;
}

const Professional: React.FC<ProfessionalProps> = ({ onDataChange, userDet, onBack, isEdit, moduleDet, roleDet, submit }) => {

    let initialFormState;
    if (userDet != null) {
        initialFormState = {
            modules: typeof userDet.internalUserModule === "string"
                ? userDet.internalUserModule.split(",").map(module => module.trim())
                : [], role: userDet.internalUserRoleId, manager: userDet.internalUserManagerId, sports: userDet.internalUserSportId,
            doj: userDet.internalUserJoiningDate, usrname: userDet.internalUserName, status: userDet.internalUserStatus
        }
    }
    else {
        initialFormState = {
            modules: '', role: '', manager: '', sports: '', doj: '', usrname: '', password: '', confirmpassword: ''
        }
    }

    useEffect(() => {
        if (userDet != null) {
            getmanagers(userDet.internalUserRoleId)
            if (userDet.internalUserRoleId == 6) {
                getSports()
            }
            setFormData(initialFormState);
            onDataChange(initialFormState);
        }
    }, [])

    const [formData, setFormData] = useState(initialFormState);
    const [managerList, setManagerList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [error, setError] = useState("");

    function getmanagers(role) {
        const mngrFetch = api.ManagerList + '/' + role;
        fetch(mngrFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setManagerList(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    function getSports() {
        const sportFetch = api.SportList;
        fetch(sportFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setSportList(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
        onDataChange(updatedData); // Send data to AddStudent
    };

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setError("Passwords do not match!");
        } else {
            setError("");
            submit;  // ✅ Only call saveinst when passwords match
        }
    };

    return (
        <form>
            <div className="card card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-6 mb-10">
                                    <label className="form-label">Modules</label>
                                    <Select
                                        isMulti
                                        value={moduleDet.filter(mdl => (Array.isArray(formData.modules) ? formData.modules.includes(mdl.moduleId.toString()) : false))
                                            .map(mdl => ({
                                                value: mdl.moduleId,
                                                label: mdl.moduleAlias
                                            }))
                                        }
                                        onChange={(selectedOptions) => {
                                            handleChange({
                                                target: {
                                                    name: "modules",
                                                    value: selectedOptions ? selectedOptions.map(option => option.value) : []
                                                }
                                            });
                                        }}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                height: "40px",  // ✅ Sets the height of the input field
                                                minHeight: "40px", // Ensures it doesn’t shrink
                                                border: "1px solid hsl(0, 0%, 80%)",
                                                borderRadius: "5px",
                                                boxShadow: "none",
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: "40px",  // ✅ Ensures selected value container follows the height
                                                display: "flex",
                                                alignItems: "center", // Keeps text vertically centered
                                                padding: "0px 10px 0px 10px"
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                margin: "0px",
                                                padding: "0px"
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                lineHeight: "40px" // ✅ Aligns placeholder text properly
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: "5px"
                                            }),
                                        }}
                                        options={moduleDet.map(mdl => ({
                                            value: mdl.moduleId,
                                            label: mdl.moduleAlias
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Role</label>
                                        <Select
                                            value={roleDet.find(rle => rle.roleId === formData.role) ? {
                                                value: formData.role,
                                                label: roleDet.find(rle => rle.roleId === formData.role).roleName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "role", value: e ? e.value : "" } });
                                                {
                                                    (e?.value >= 3 && e?.value <= 6) ?
                                                        getmanagers(e.value) : setManagerList([]);
                                                }
                                                if (e?.value == 6) {
                                                    getSports()
                                                }
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Role"
                                            options={roleDet.map(rle => ({
                                                value: rle.roleId,
                                                label: rle.roleName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Manager</label>
                                        <Select
                                            value={managerList.find(mgr => mgr.internalUserId === formData.manager) ? {
                                                value: formData.manager,
                                                label: managerList.find(mgr => mgr.internalUserId === formData.manager).internalUserFirstName + " " +
                                                    managerList.find(mgr => mgr.internalUserId === formData.manager).internalUserLastName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "manager", value: e ? e.value : "" } });
                                            }}
                                            isDisabled={formData.role < 3 || formData.role > 6}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            options={managerList.map(mgr => ({
                                                value: mgr.internalUserId,
                                                label: mgr.internalUserFirstName + " " + mgr.internalUserLastName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sports</label>
                                        <Select
                                            value={sportList.find(sprt => sprt.sportId === formData.sports) ? {
                                                value: formData.sports,
                                                label: sportList.find(sprt => sprt.sportId === formData.sports).sportName
                                            } : null}
                                            onChange={(e) => {
                                                if (formData.role != 6) {
                                                    handleChange({ target: { name: "sport", value: "" } }); // Reset sport if role is not 6
                                                } else {
                                                    handleChange({ target: { name: "sport", value: e ? e.value : "" } });
                                                }
                                            }}
                                            isDisabled={formData.role != 6}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            options={sportList.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <label className="form-label">Date of Joining</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="doj"
                                        value={formData.doj}
                                        onChange={handleChange}
                                        placeholder="Joining Date" />
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <label className="form-label">User Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="usrname"
                                        value={formData.usrname}
                                        onChange={handleChange}
                                        placeholder="User Name" />
                                </div>
                                {(userDet == null) ?
                                    <>
                                        <div className="col-md-6 mb-10">
                                            <label className="form-label">Password</label>
                                            <input
                                                className="form-control"
                                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                                name="password"
                                                placeholder="Password"
                                                type="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                            />
                                            {error && <div className="alert alert-danger">{error}</div>}
                                        </div>
                                        <div className="col-md-6 mb-10">
                                            <label className="form-label">Confirm Password</label>
                                            <input
                                                className="form-control"
                                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                                name="confirmpassword"
                                                placeholder="Confirm Password"
                                                type="password"
                                                value={formData.confirmpassword}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    validatePasswords(formData.password, e.target.value);  // ✅ Pass values properly
                                                }}
                                            />
                                        </div>
                                    </>
                                    : ""
                                }
                                {(userDet != null) ?
                                    <>
                                        <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={formData.status === '1'}
                                                    name="status"
                                                    // onChange={(e) => {
                                                    //     formData.status(e.target.checked ? '1' : '0')
                                                    // }}
                                                    onChange={(e) => {
                                                        setFormData((prevData) => ({
                                                            ...prevData,
                                                            status: e.target.checked ? '1' : '0',
                                                        }));
                                                        onDataChange({ ...formData, status: e.target.checked ? '1' : '0' }); // Ensure the updated value is passed
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                    : null}
                                <div className="d-md-flex justify-content-between align-items-center">
                                    <div className="qty-item text-center">
                                        <Link className="btn btn-primary me-3 btn-icon" to="#" onClick={onBack}><i className="feather-arrow-left-circle me-1" /> Back</Link>
                                    </div>
                                    <div className="qty-item text-center">
                                        <Button
                                            className="btn-primary"
                                            variant="success"
                                            // onClick={saveStudent}
                                            onClick={submit}
                                        >
                                            <b>{isEdit ? "Update" : "Save"}</b>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Professional;